const warns = new Set<string>();

export function warnOnce(message: string): void {
  if (warns.has(message)) {
    return;
  }
  warns.add(message);
  global.console.warn(message);
}
